import { createFileRoute } from "@tanstack/react-router";
import BirthdayRequestPage from "@/site/pages/birthday-request";

/**
 * The Birthday Request responder surface (PRD 05 §6.3–6.5, legacy give-birthday form).
 * The token IS the credential — public route, simple header/footer chrome (like the
 * `/s/` sign surface). Resolves the scope-appropriate form or the expired dead-link.
 * Path is `/dob/:token` to mirror the legacy general-request link (birthdayalarm.com/dob/<code>).
 */
export const Route = createFileRoute("/dob/$token")({
  component: BirthdayRequestPage,
});
